module.exports = __webpack_public_path__ + "img/symphony_855_mandarine.339a4d44.jpg";